import api from "./api";

const getMongoUsage = async () => {
  const response = await api.get(`/usage/mongo`);
  return response.data;
};

const getMediaUsage = async () => {
  const response = await api.get(`/usage/media`);
  return response.data;
};

const getTwilioUsage = async () => {
  const response = await api.get(`/usage/twilio`);
  return response.data;
};

const usageService = {
  getMongoUsage,
  getMediaUsage,
  getTwilioUsage,
};

export default usageService;
